import { useTranslate } from '@festina-life/ui/hooks'
import { SimpleModal } from '@festina-life/ui/structure'
import { useRef, useState } from 'react'

import { useTemplateId } from '../../hooks/useTemplateId'
import { ExpandedInheritanceDiagram } from '../inheritanceHierarchy/ExpandedInheritanceDiagram'
import { InheritanceDiagram } from '../inheritanceHierarchy/InheritanceDiagram'
import { TimelineScaleControls } from '../versionedTimeline/TimelineScaleControls'
import { TemplateVersionsArrows } from './TemplateVersionsArrows'

export const InheritanceTimelineDiagram = () => {
  const translate = useTranslate()
  const templateId = useTemplateId()

  const controlsRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false)

  const [currentScale, setCurrentScale] = useState(1)
  const [nodeHeight, setNodeHeight] = useState(0)

  return (
    <div>
      <div
        className="group relative grid grid-cols-[auto_1fr]"
        ref={containerRef}
      >
        <div className="flex w-auto flex-row" ref={controlsRef}>
          <TimelineScaleControls
            step={0.5}
            onChange={setCurrentScale}
            onOpenDetails={() => setIsDetailsModalOpen(true)}
          />
          <InheritanceDiagram
            onNodeHeightChanged={setNodeHeight}
            onViewMore={() => setIsDetailsModalOpen(true)}
          />
          <SimpleModal
            isOpen={isDetailsModalOpen}
            title={translate(
              'templateViewer.sidebar.inheritanceDiagram.modal.title',
              { templateName: templateId },
            )}
            closeConfiguration={{
              onClose: () => setIsDetailsModalOpen(false),
              label: translate('close'),
            }}
          >
            <ExpandedInheritanceDiagram />
          </SimpleModal>
        </div>
        <TemplateVersionsArrows
          nodeHeight={nodeHeight}
          currentScale={currentScale}
          containerRef={containerRef}
          controlsRef={controlsRef}
        />
      </div>
    </div>
  )
}
